import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade";
import queryString from "query-string";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "filterMenu"];

  connect() {
    this.inintialize();
  }

  inintialize() {
    const mobileFilterToggle = document.querySelector(
      "#mobilefilterMenuToggle"
    );

    if (mobileFilterToggle) {
      mobileFilterToggle.addEventListener("change", () => {
        const target = document.querySelector(
          ".filter-tree-wrap .accordion-wrap__main"
        );

        if (target) {
          if (mobileFilterToggle.checked) {
            disableBodyScroll(target);
          } else {
            enableBodyScroll(target);
          }
        }
      });
    }
  }

  handleChange(e) {
    const query = queryString.parse(window.location.search);
    if (e.target.name === "sort_by") {
      const sortValue = e.target.value;
      query.sort_by = sortValue;
    }

    const viewValue = this.formTarget.querySelector(
      '[name="view"]:checked'
    ).value;

    // Get the sort value and view value
    // Rewrite the query string by updating the values and using window.location
    // to send to the entire query string with new values
    query.view = viewValue;

    window.location = `${window.location.origin}${
      window.location.pathname
    }?${queryString.stringify(query)}`;
    // this.formTarget.submit();
  }

  clearFilters() {
    window.location.search = "";
  }
}
